import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=a585833a&scoped=true&"
var script = {}
import style0 from "./agreement.vue?vue&type=style&index=0&id=a585833a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a585833a",
  null
  
)

export default component.exports